import { getAppConfig } from '@services/config';

const appConfig = getAppConfig();

type EnergyLabelImageProps = {
    label?: string;
    onClick?: () => void;
};

export function EnergyLabelImage({ onClick, label }: Readonly<EnergyLabelImageProps>) {
    if (label === undefined) {
        return null;
    }

    return (
        <button className='button-clear' onClick={onClick}>
            <img
                src={`${appConfig.assets.cmsImages.url}/original/image/CMS/ecommerce/energy-label/${label.toLowerCase()}.svg`}
                alt={`Classe énergétique : ${label}`}
                width={60}
                loading='lazy'
            />
        </button>
    );
}
